import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
// import FeatureCard from "./../../student/FeatureCard/FeatureCard";
import "./../../../assets/css/general/AboutUs/AboutUs.css";

const AboutUs = () => {
  const navigate = useNavigate();

  // Scroll Animation Effect
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add("animate-in");
          }, index * 150);
        }
      });
    }, observerOptions);

    // Observe all animated elements
    const animatedElements = document.querySelectorAll(".animate-on-scroll");
    animatedElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      icon: "🎓",
      title: "Skilled Instructors",
      description:
        "Learn from industry experts with years of real-world experience.",
    },
    {
      icon: "🌐",
      title: "Online Classes",
      description: "Access live and recorded sessions anytime, anywhere.",
    },
    {
      icon: "🏠",
      title: "Home Projects",
      description: "Build real-world projects to strengthen your portfolio.",
    },
    {
      icon: "📚",
      title: "Book Library",
      description: "Access our extensive digital library of resources.",
    },
  ];

  const instructors = [
    {
      name: "Mam Sadaf",
      designation: "Senior Web Developer",
      image:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400",
      facebook: "#",
      twitter: "#",
      instagram: "#",
    },
    {
      name: "Mam Maheen",
      designation: "AI/ML Specialist",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
      facebook: "#",
      twitter: "#",
      instagram: "#",
    },
    {
      name: "Mam Tabinda",
      designation: "Full Stack Developer",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400",
      facebook: "#",
      twitter: "#",
      instagram: "#",
    },
    {
      name: "Mam Anam",
      designation: "Mobile App Developer",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400",
      facebook: "#",
      twitter: "#",
      instagram: "#",
    },
  ];

  return (
    <div className="about-us-page">
      {/* Modern Animated Hero Section with Code Background */}
      <div className="modern-about-page">
        {/* HTML Code Background with Red Overlay */}
        <div className="code-background-image"></div>
        <div className="red-overlay"></div>

        {/* Animated Bubbles */}
        <div className="bubbles-container">
          <div className="bubble bubble-1"></div>
          <div className="bubble bubble-2"></div>
          <div className="bubble bubble-3"></div>
          <div className="bubble bubble-4"></div>
          <div className="bubble bubble-5"></div>
          <div className="bubble bubble-6"></div>
          <div className="bubble bubble-7"></div>
        </div>

        <Container className="hero-container-centered">
          <div className="about-content-wrapper">
            {/* Left Side - Text Content */}
            <div className="about-text-side">
              <h1 className="about-main-title">ABOUT US</h1>
              <p className="about-description-text">
                Tech Mentor Hub empowers IT students with smart learning, expert
                mentorship, and real-world skills to build successful tech
                careers.
              </p>
              <Button
                className="learn-more-button"
                as={Link}
                to="/student/dashboard"
              >
                LEARN MORE
              </Button>
            </div>

            {/* Right Side - Animated Bubbles Illustration */}
            <div className="about-illustration-side">
              <div className="bubbles-illustration">
                <div className="bubble-large bubble-anim-1">
                  <span className="bubble-text">Expert Mentors</span>
                </div>
                <div className="bubble-medium bubble-anim-2">
                  <span className="bubble-text">AI Learning</span>
                </div>
                <div className="bubble-medium bubble-anim-3">
                  <span className="bubble-text">Real Projects</span>
                </div>
                <div className="bubble-small bubble-anim-4">
                  <span className="bubble-text">24/7 Support</span>
                </div>
                <div className="bubble-small bubble-anim-5">
                  <span className="bubble-text">Certificates</span>
                </div>
                <div className="bubble-tiny bubble-anim-6"></div>
                <div className="bubble-tiny bubble-anim-7"></div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      {/* Features Section with Fixed Spacing */}
      <section className="features-section">
        <Container>
          <Row className="g-4 justify-content-center">
            {features.map((feature, index) => (
              <Col key={index} xs={12} sm={6} md={6} lg={3}>
                <div className="feature-card-small animate-on-scroll">
                  <div className="feature-icon-small">{feature.icon}</div>
                  <h3 className="feature-title-small">{feature.title}</h3>
                  <p className="feature-desc-small">{feature.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* About Content Section - Updated Layout */}
      <section className="about-main-section">
        <Container>
          <Row className="g-0 align-items-center about-content-row">
            <Col lg={6} className="about-left-col">
              <div className="about-image-box">
                <img
                  src="https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800"
                  alt="Library Books"
                  className="about-image-full"
                />
              </div>
            </Col>

            <Col lg={6} className="about-right-col">
              <div className="about-text-box">
                <div className="about-label">
                  <span className="label-line"></span>
                  <span className="label-text">ABOUT US</span>
                </div>

                <h2 className="about-title">Welcome to Tech Mentor Hub</h2>

                <p className="about-para">
                  Tech Mentor Hub is a learning platform designed for IT
                  department students. We offer AI-powered tutoring, structured
                  roadmaps, expert mentorship, and hands-on coding challenges to
                  help students learn faster and grow confidently in their tech
                  careers.
                </p>

                <p className="about-para">
                  Our platform is built to make complex IT concepts easy to
                  understand, with clear guidance at every step. Students can
                  practice real-world projects, track their progress, and get
                  instant support whenever they need help.
                </p>

                <Row className="about-list-row">
                  <Col xs={6}>
                    <ul className="about-list">
                      <li>
                        <span className="arrow-icon">→</span> Skilled
                        Instructors
                      </li>
                      <li>
                        <span className="arrow-icon">→</span> International
                        Certificate
                      </li>
                      <li>
                        <span className="arrow-icon">→</span> Online Classes
                      </li>
                    </ul>
                  </Col>
                  <Col xs={6}>
                    <ul className="about-list">
                      <li>
                        <span className="arrow-icon">→</span> Home Projects
                      </li>
                      <li>
                        <span className="arrow-icon">→</span> Book Library
                      </li>
                      <li>
                        <span className="arrow-icon">→</span> 24/7 Support
                      </li>
                    </ul>
                  </Col>
                </Row>

                <button className="about-btn">READ MORE</button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Vision Section */}
      <section className="vision-section">
        <Container>
          <div className="vision-content">
            <h2 className="vision-heading">Our Vision</h2>
            <p className="vision-text">
              Our vision is to empower IT students by providing a smart,
              easy-to-use learning platform that simplifies complex technology
              concepts, builds real-world skills, and prepares students for
              successful careers in the tech industry.
            </p>
          </div>
        </Container>
      </section>

      {/* Instructors Section - Centered Header */}
      <section className="instructors-section">
        <Container>
          <div className="section-header-centered">
            <span className="section-subtitle">INSTRUCTORS</span>
            <h2 className="section-title">Expert Instructors</h2>
          </div>

          <Row className="g-4 justify-content-center">
            {instructors.map((instructor, index) => (
              <Col key={index} xs={12} sm={6} md={6} lg={3}>
                <div className="instructor-card animate-on-scroll">
                  <div className="instructor-image-wrapper">
                    <img
                      src={instructor.image}
                      alt={instructor.name}
                      className="instructor-image"
                    />
                    <div className="instructor-social">
                      <a href={instructor.facebook} className="social-icon">
                        <span>f</span>
                      </a>
                      <a href={instructor.twitter} className="social-icon">
                        <span>t</span>
                      </a>
                      <a href={instructor.instagram} className="social-icon">
                        <span>i</span>
                      </a>
                    </div>
                  </div>
                  <div className="instructor-info">
                    <h3 className="instructor-name">{instructor.name}</h3>
                    <p className="instructor-designation">
                      {instructor.designation}
                    </p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default AboutUs;
